import { css } from 'linaria';

export const classNames = {
  image: css`
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  `,
  plx: css`
    // We add on 400px here as a buffer space to work with parallaxing.
    // Whatever the amount to parallax is set to * 2.
    height: calc(100% + 400px);
    position: absolute;
    top: 0;
    width: 100%;
  `,
};
